import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { ENDPOINTS } from '../../constants/tableTypes'
import {
  STORE_USER_ENDPOINTS,
  STORE_SELECTED_ENDPOINTS,
} from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  roleName: null,
  roleDescription: null,
  selectedEndpoints: [],
  content: [],
  total_elements: 0,
}

const endpointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_USER_ENDPOINTS:
      return {
        ...state,
        content: action.endpoints,
      }
    case STORE_SELECTED_ENDPOINTS:
      return {
        ...state,
        roleName: action.roleName,
        roleDescription: action.roleDescription,
        selectedEndpoints: action.selectedEndpoints,
      }
    default:
      return reducers.dataTable.tableFetchReducer(ENDPOINTS, state, action)
  }
}

export default combineReducers({
  data: endpointsReducer,
  tableInfo: tableReducer,
})

export { initialState, endpointsReducer }
